import { AlertTriangle, Check, Loader2, X } from "lucide-react";

type Status = "available" | "taken" | "unknown" | "checking";

interface StatusBadgeProps {
  status: Status;
}

const labels: Record<Status, string> = {
  available: "Available",
  taken: "Taken",
  unknown: "Review",
  checking: "Checking"
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const Icon = status === "available" ? Check : status === "taken" ? X : status === "checking" ? Loader2 : AlertTriangle;
  return (
    <span className={`status-badge ${status}`}>
      <Icon aria-hidden="true" />
      {labels[status]}
    </span>
  );
}

